import React from "react";
import { defineMessage, useIntl } from "react-intl";
import { LineChart } from "../charts/LineChart";
import { withFigureIO } from "../components/figure";
import { metadata } from "../data/data_finance_aid_fig_GPE";
import { datasets } from "../data/data_finance_aid_fig_GPE_datasets";
import { mkGemDataDecoder } from "../domain";
import { useMedia } from "../hooks";
import * as M from "../materials";
import { breakpoints } from "../materials/consts.stylex";
import { io } from "../prelude";
export * from "../data/data_finance_aid_fig_GPE";
const Type = io.keyof({
    utilized: null,
    disbursement: null
});
const typeLookup = {
    utilized: defineMessage({
        id: "fig.finance.aid.GPE.utilized",
        defaultMessage: "GPE financial report - Utilized"
    }),
    disbursement: defineMessage({
        id: "fig.finance.aid.GPE.disbursement",
        defaultMessage: "OECD CRS database - Disbursements"
    })
};
export const Data = mkGemDataDecoder([
    "value",
    "ind_id",
    "year"
], {
    type: Type
});
export const Chart = ({ data })=>{
    const intl = useIntl();
    const screenMDown = !useMedia(breakpoints.m);
    const entityData = React.useMemo(()=>data.map((x)=>({
                ...x,
                type: intl.formatMessage(typeLookup[x.type])
            })), [
        intl,
        data
    ]);
    return <LineChart tLabel={(s)=>s} height={screenMDown ? M.chartHeight.s : M.chartHeight.m} x="year" yTicks={[
        0,
        0.2,
        0.4,
        0.6,
        0.8
    ]} timeParse="%Y" timeFormat="%Y" numberFormat=".2f" category="datum.type" yAxisLabel={intl.formatMessage(defineMessage({
        id: "USD billion",
        defaultMessage: "USD billion"
    }))} tooltipFormatX={(x)=>x.type} colorLegend values={entityData} showTooltip yNice={0}/>;
};
export default withFigureIO({
    url: new URL("../data/data_finance_aid_fig_GPE.json", import.meta.url).href,
    csv: new URL("../data/data_finance_aid_fig_GPE.zip", import.meta.url).href,
    xlsx: new URL("../data/data_finance_aid_fig_GPE.xlsx", import.meta.url).href,
    metadata,
    Data,
    Chart,
    size: "main",
    datasets
});
